export class ExclusionPatternFilterConditions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "ExclusionPatternResourceFilter",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "FindingObjectTypeFilters",
            "format": ""
        },
        {
            "name": "detector",
            "baseName": "detector",
            "type": "DetectorTypeFilters",
            "format": ""
        },
        {
            "name": "path",
            "baseName": "path",
            "type": "FreeTextFilters",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ExclusionPatternFilterConditions.attributeTypeMap;
    }
    constructor() {
    }
}
